import type { CityConfig } from "../city-template/types";

export const morrisvilleConfig: CityConfig = {
  city: "Morrisville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "morrisville",
  route: "/cities/morrisville",
  title: "Emergency Passport Morrisville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Morrisville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving RDU Airport area and the Research Triangle. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Morrisville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Morrisville and RDU Airport area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Morrisville%20North%20Carolina%20suburban%20landscape%20near%20RDU%20Airport%20with%20modern%20office%20parks%20and%20tech%20corridors%2C%20tree-lined%20residential%20streets%20with%20contemporary%20homes%2C%20warm%20golden%20hour%20light%20over%20the%20Research%20Triangle%20central%20hub%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20vibrant%20green%20colors%20and%20modern%20suburban%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=morrisville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Morrisville North Carolina suburban landscape near RDU Airport with modern office parks at golden hour",
  geoPosition: "35.8235;-78.8256",
  geoPlacename: "Morrisville, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 280 miles north of Morrisville — about 4.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Morrisville", zips: "27560" },
    { name: "Cary", zips: "27511, 27513, 27518, 27519" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Holly Springs", zips: "27540" },
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Garner", zips: "27529" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Wendell", zips: "27591" },
    { name: "Clayton", zips: "27520, 27527" },
    { name: "Smithfield", zips: "27577" },
    { name: "Burlington", zips: "27215, 27216, 27217" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Charlotte", zips: "28201–28299" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Morrisville departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "RDU Airport Hub", desc: "Serving Morrisville, Cary, and the central Research Triangle" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Durham, NC", route: "/cities/durham" },
    { name: "Emergency passport help in Cary, NC", route: "/cities/cary" },
    { name: "Urgent passport services in Apex, NC", route: "/cities/apex" },
    { name: "Same-day passport help in Chapel Hill, NC", route: "/cities/chapel-hill" },
    { name: "Passport courier services in Wake Forest, NC", route: "/cities/wake-forest" },
    { name: "Fast passport renewal in Garner, NC", route: "/cities/garner" },
    { name: "Passport courier services in Holly Springs, NC", route: "/cities/holly-springs" },
    { name: "Passport courier services in Fuquay-Varina, NC", route: "/cities/fuquay-varina" },
    { name: "Emergency passport help in Clayton, NC", route: "/cities/clayton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Morrisville remotely via secure courier. We do not have a walk-in office in Morrisville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wake County and the Research Triangle travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Wake County and the central Research Triangle metropolitan region",
  serviceAreaIntro: "From the tech corridors of Morrisville Park to the residential neighborhoods of Carpenter, from the RDU Airport area to the bustling streets of Cary, from downtown Raleigh to Durham's university district, from Apex to Chapel Hill, from Holly Springs to Fuquay-Varina, from Wake Forest to Garner, from Knightdale to Clayton — Fast Passport Center serves the entire Morrisville region. We regularly help travelers from the Research Triangle, the Triad, and the Charlotte metro get their passports fast.",
  nearbyCitiesIntro: "We serve all Morrisville neighborhoods and the surrounding central Research Triangle area including Cary, Raleigh, Durham, Apex, Chapel Hill, Holly Springs, Fuquay-Varina, Wake Forest, Garner, Knightdale, Zebulon, Wendell, Clayton, Smithfield, Burlington, Greensboro, Winston-Salem, and Charlotte. If you are anywhere in the Research Triangle, the Triad, or central North Carolina, we have you covered.",
  howItWorksIntro: "Most Morrisville travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Morrisville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Morrisville and Research Triangle travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Morrisville? Here are the most common ones we hear from Wake County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Morrisville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Dr. Jennifer L.",
      location: "Morrisville, NC",
      rating: 5,
      text: "Business trip to London came up with 4 days notice. Fast Passport Center had my emergency passport ready in 28 hours. I never left Morrisville. The dedicated agent was outstanding.",
      service: "Emergency Passport",
    },
    {
      name: "Robert M.",
      location: "Cary, NC",
      rating: 5,
      text: "My passport expired the week before our family cruise. Fast Passport Center got my renewal in 3 days. The document review caught a photo issue before submission. Saved our vacation.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda K.",
      location: "Durham, NC",
      rating: 5,
      text: "First passport for my 9-year-old before a school trip to France. Fast Passport Center walked us through every requirement. Had her passport in 4 days. So grateful for the Triangle coverage.",
      service: "Child Passport",
    },
    {
      name: "Steve T.",
      location: "Raleigh, NC",
      rating: 5,
      text: "Lost my passport 2 days before a conference in Singapore. Fast Passport Center had a replacement in 32 hours. Their RDU area service is unbeatable.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "morrisville-1",
      name: "Morrisville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3601 Davis Dr",
      city: "Morrisville",
      state: "NC",
      zip: "27560",
      phone: "(919) 467-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Morrisville, RDU area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Morrisville facility near RDU Airport. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "morrisville-2",
      name: "Cary Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 N Academy St",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles southeast of Morrisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service facility for Cary and Morrisville residents. Photo services nearby at CVS and Walgreens.",
      icon: "ri-mail-line",
    },
    {
      id: "morrisville-3",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "414 E Holding Ave",
      city: "Raleigh",
      state: "NC",
      zip: "27610",
      phone: "(919) 755-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles east of Morrisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Raleigh metro. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "morrisville-4",
      name: "Durham Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "323 E Chapel Hill St",
      city: "Durham",
      state: "NC",
      zip: "27701",
      phone: "(919) 683-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northwest of Morrisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Durham County and west Wake County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "morrisville-5",
      name: "Apex Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 E Williams St",
      city: "Apex",
      state: "NC",
      zip: "27502",
      phone: "(919) 362-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southwest of Morrisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Apex and Holly Springs area. Less crowded than Raleigh. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "morrisville-6",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "300 S Salisbury St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "12 miles east of Morrisville, Courthouse",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Morrisville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Morrisville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Morrisville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Morrisville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Morrisville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Morrisville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Morrisville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Morrisville?", a: "Fast Passport Center offers fast passport renewal in Morrisville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Morrisville?", a: "The nearest regional passport agency to Morrisville is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 280 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Morrisville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Morrisville?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4.5 hours from Morrisville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wake County and Research Triangle residents." },
    { q: "Do you serve the entire Research Triangle area?", a: "Absolutely. Fast Passport Center serves the entire Research Triangle metropolitan area including Morrisville, Cary, Raleigh, Durham, Apex, Chapel Hill, Holly Springs, Fuquay-Varina, Wake Forest, Garner, Knightdale, Zebulon, Wendell, and Clayton. Our courier service works seamlessly from any address in Wake, Durham, or Orange counties." },
    { q: "Can I expedite a child passport in Morrisville?", a: "Yes. Fast Passport Center expedites child passports in Morrisville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wake County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Morrisville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Morrisville", address: "1000 Market Center Dr, Morrisville, NC 27560", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Morrisville", address: "1000 Market Center Dr, Morrisville, NC 27560", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Morrisville", address: "1000 Market Center Dr, Morrisville, NC 27560", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Cary", address: "1010 SE Cary Pkwy, Cary, NC 27518", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Cary", address: "1140 Kildaire Farm Rd, Cary, NC 27511", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Raleigh", address: "3600 New Bern Ave, Raleigh, NC 27610", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Durham", address: "3713 N Roxboro St, Durham, NC 27704", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Raleigh", address: "435 S Salisbury St, Raleigh, NC 27601", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Morrisville",
      address: "3911 NC-55, Cary, NC 27519",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended. Serves Morrisville and western Cary.",
      featured: true,
    },
    {
      name: "NC DMV — Raleigh",
      address: "3231 Avent Ferry Rd, Raleigh, NC 27606",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Raleigh and western Wake County. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Cary",
      address: "1100 N Harrison Ave, Cary, NC 27513",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Durham",
      address: "3925 N Duke St, Durham, NC 27704",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Durham and Chapel Hill area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "5 miles east of Morrisville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. American, Delta, and United hub. Only 10 minutes from Morrisville.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "150 miles southwest of Morrisville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major alternative hub for the Charlotte metro area. Additional international routes.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "65 miles west of Morrisville",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Wake County Register of Deeds", url: "https://www.wake.gov/departments-government/register-deeds", description: "Birth, death, and marriage records for Wake County" },
    { name: "Wake County Superior Court", url: "https://www.nccourts.gov/locations/wake-county", description: "Divorce records and court documents for Wake County" },
  ],
};